import { ImageUpload } from '@/components/ImageUpload'
import { Label } from '@/components/ui/label'
import { useFileUploadField } from '@/hooks/useFileUpload'
import { User } from 'lucide-react'
import { type ReactNode } from 'react'

export function ImageUploadField({
  label,
  field,
  maxImages,
  uploadText,
  testId,
}: {
  label: ReactNode
  field: ReturnType<typeof useFileUploadField>
  maxImages: number
  uploadText?: string
  testId?: string
}) {
  return (
    <div className="flex flex-col gap-1.5">
      {typeof label === 'string' ? <Label className="text-xs">{label}</Label> : label}
      <ImageUpload
        files={field.files}
        imageIds={field.imageIds}
        onChange={field.handleChange}
        onRemoveExisting={field.handleRemoveExisting}
        maxImages={maxImages}
        testId={testId}
      />
      {field.isUploading ? (
        <p className="text-[11px] text-muted-foreground">
          {uploadText}
          {field.uploadProgress ? ` ${field.uploadProgress}%` : '...'}
        </p>
      ) : null}
    </div>
  )
}

export function CurrentUserNote({ label, name }: { label: string; name?: string }) {
  return (
    <div className="rounded-lg bg-secondary/30 p-3">
      <p className="flex items-center gap-1.5 text-[10px] text-muted-foreground">
        <User className="size-3" />
        {label}: {name}
      </p>
    </div>
  )
}
